import { useState, useEffect } from "react"
import styles from "../../../../../styles/Participant-Employment.module.css"
import CheckboxField from "../../../Utils/CheckboxField"
const PlansForSchoolAndTrainingCheckboxForm = ({
  label,
  setValue,
  valueName,
  value,
  callback,
}) => {
  const [selected, setSelected] = useState({
    accessToAComputer: value?.accessToAComputer,
    quietPlaceToStudy: value?.quietPlaceToStudy,
    financialAid: value?.financialAid,
    mentalHealthSupport: value?.mentalHealthSupport,
    helpWithTransitRoute: value?.helpWithTransitRoute,
    helpWithStudyCalendar: value?.helpWithStudyCalendar,
    helpNavigatingCampus: value?.helpNavigatingCampus,
    helpTalkingToTeachers: value?.helpTalkingToTeachers,
    computingLiteracy: value?.computingLiteracy,
    transitCard: value?.transitCard,
    bookSupplies: value?.bookSupplies,
    elderCare: value?.elderCare,
    helpStudying: value?.helpStudying,
    childCare: value?.childCare,
    moreSupportFromFamily: value?.moreSupportFromFamily,
    other: value?.other,
  })
  useEffect(() => {
    setValue(valueName, selected)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected])

  return (
    <>
      <label className={styles.label}>{label}</label>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flexBasis: "100%",
            flex: "1",
            color: "#383838",
          }}
        >
          <CheckboxField
            label={"Access to a computer"}
            value={selected}
            setValue={setSelected}
            valueName={"accessToAComputer"}
          />
          <CheckboxField
            label={"Quiet place to study"}
            value={selected}
            setValue={setSelected}
            valueName={"quietPlaceToStudy"}
          />
          <CheckboxField
            label={"Financial Aid"}
            value={selected}
            setValue={setSelected}
            valueName={"financialAid"}
          />
          <CheckboxField
            label={"Mental health support"}
            value={selected}
            setValue={setSelected}
            valueName={"mentalHealthSupport"}
          />
          <CheckboxField
            label={"Help with transit route"}
            value={selected}
            setValue={setSelected}
            valueName={"helpWithTransitRoute"}
          />
          <CheckboxField
            label={"Help with a study calendar and time management"}
            value={selected}
            setValue={setSelected}
            valueName={"helpWithStudyCalendar"}
          />
          <CheckboxField
            label={"Help navigating campus"}
            value={selected}
            setValue={setSelected}
            valueName={"helpNavigatingCampus"}
          />
          <CheckboxField
            label={"Help talking to teachers/instructors"}
            value={selected}
            setValue={setSelected}
            valueName={"helpTalkingToTeachers"}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flexBasis: "100%",
            flex: "1",
            color: "#383838",
          }}
        >
          <CheckboxField
            label={"Computer Literacy Training"}
            value={selected}
            setValue={setSelected}
            valueName={"computingLiteracy"}
          />
          <CheckboxField
            label={"Transit card"}
            value={selected}
            setValue={setSelected}
            valueName={"transitCard"}
          />
          <CheckboxField
            label={"Books/Supplies"}
            value={selected}
            setValue={setSelected}
            valueName={"bookSupplies"}
          />
          <CheckboxField
            label={"Eldercare"}
            value={selected}
            setValue={setSelected}
            valueName={"elderCare"}
          />
          <CheckboxField
            label={"Help studying"}
            value={selected}
            setValue={setSelected}
            valueName={"helpStudying"}
          />
          <CheckboxField
            label={"Childcare"}
            value={selected}
            setValue={setSelected}
            valueName={"childCare"}
          />
          <CheckboxField
            label={"More support from family/friends"}
            value={selected}
            setValue={setSelected}
            valueName={"moreSupportFromFamily"}
          />
          <CheckboxField
            label={"Other"}
            value={selected}
            setValue={setSelected}
            valueName={"other"}
            callback={callback}
          />
        </div>
      </div>
    </>
  )
}
export default PlansForSchoolAndTrainingCheckboxForm
